import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { COLORS } from "../../../constants/colors";
import { UserProfileContext } from "../../../context/userProfileContext";
import {
  errorNotifier,
  infoNotifier,
} from "../../../components/NotificationHandler";
import { addFamilyMember } from "../services";

export const AddFamilyMemberForm = ({ onClose, userId, refreshFamily }) => {
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);
  const bgColor = useColorModeValue(COLORS.primary, COLORS.green);
  const { userProfile } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    tenantName: "",
    familyPhone: "",
    relationship: "",
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Add new family member
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formValues.tenantName) {
      errorNotifier("Family member name is required");
      return;
    }

    if (!formValues.relationship || formValues.relationship === "Select relationship") {
      errorNotifier("Relationship is required");
      return;
    }

    // Create payload for adding family member
    const payload = {
      familyName: formValues.tenantName,
      relationship: formValues.relationship,
      phoneNumber: formValues.familyPhone || "",
      userId: userId,
      tenantName: userProfile?.tenantName,
    };

    // Call service to add family member
    const result = await addFamilyMember(payload, setLoading);
    
    if (result.success) {
      onClose();
      refreshFamily(); // Refresh the family list
    }
  };

  const inputStyle = {
    bg: "white",
    color: "black",
    _placeholder: { opacity: 1, color: "gray.500" },
    border: "1px solid",
    borderColor: "gray.300",
    borderRadius: "md",
    h: "50px",
    _focus: {
      borderColor: cardBg,
      boxShadow: `0 0 0 1px ${cardBg}`,
    },
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <Stack spacing="4">
        <FormControl isRequired>
          <FormLabel color={cardBg}>Member's FullName</FormLabel>
          <Input
            {...inputStyle}
            name="tenantName"
            placeholder="Enter family member name"
            value={formValues.tenantName}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel color={cardBg}>Phone Number</FormLabel>
          <Input
            {...inputStyle}
            name="familyPhone"
            placeholder="Enter phone number"
            value={formValues.familyPhone}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl isRequired>
          <Text color={cardBg} mb="2">Member's Relationship</Text>
          <Select
            {...inputStyle}
            name="relationship"
            value={formValues.relationship}
            onChange={handleChange}
          >
            <option>Select relationship</option>
            <option value="spouse">Spouse</option>
            <option value="child">Child</option>
            <option value="sibling">Sibling</option>
            <option value="uncle">Uncle</option>
            <option value="aunt">Aunt</option>
            <option value="parent">Parent</option>
            <option value="in-Law">In-Law</option>
            <option value="cousin">Cousin</option>
            <option value="nephew">Nephew</option>
            <option value="niece">Niece</option>
            <option value="friend">Friend</option>
            <option value="others">Others</option>
          </Select>
        </FormControl>

        <Button
          type="submit"
          bg={bgColor}
          color="white"
          _hover={{ opacity: 0.8 }}
          isLoading={loading}
          h="50px"
          mt={4}
        >
          Add Members
        </Button>
      </Stack>
    </Box>
  );
};